import React from "react";

export enum ToastState {
  Complete,
  Error,
  InProgress,
}

export interface ToastDetails {
  id?: string;
  title: string;
  message?: React.ReactNode;
  state: ToastState;
}
